
<template>
<div class="loader">

  <van-space direction="vertical" fill>

    <van-image
    :show-loading = false
      width="20rem"
      fit="contain"
      src="https://admin-fibre.gigamedia.net/images/logo/logo-GGM-SmartBS-bleu.svg"
    />



    <van-loading class="m-t4" type="spinner" color="#01458c" size="65px" />

    <van-image
    class="load_pret_logo"
    :show-loading = false
      width="13rem"
      fit="contain"
      src="https://admin-fibre.gigamedia.net/images/logo/picto_pre-t.svg"
    />


</van-space>


</div>

      
</template>

<script>

export default {
 
}
</script>

<style scoped>

/* Absolute Center Spinner */
.loader {
  position: fixed;
    z-index: 999;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    text-align: center;
    height: 77vh;
}

</style>